import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileNameGeneratorDialogData } from './file-name-generator-dialog.service';
import { FileNameGeneratorComponent } from '../file-name-generator/file-name-generator.component';
import { MatButton } from '@angular/material/button';

@Component({
    template: `
        <sphere-file-name-generator
            [fileNameInput]="data.fileName"
            [name]="data.taskName"
            [category]="data.taskCategory"
            [isFileNameMatched]="data.isFileNameMatched || false"
            (fileNameChange)="patchFileName($event)"
            (isFileNameFormValid)="isFileNameFormValid($event)"
        ></sphere-file-name-generator>

        <div class="file-name__actions">
            <button mat-button (click)="closeDialog()">CANCEL</button>
            <button mat-raised-button color="primary" (click)="closeDialog(fileNameOutput)" [disabled]="isSubmitBtnDisabled">SAVE</button>
        </div>
    `,
    styles: [
        `
            :host {
                display: block;
                height: 720px;
            }

            .file-name__actions {
                display: flex;
                justify-content: flex-end;
                align-items: flex-end;
                gap: 10px;
                padding: 20px;
            }
        `
    ],
    imports: [FileNameGeneratorComponent, MatButton]
})
export class FileNameGeneratorDialogComponent {
    private dialogRef = inject<MatDialogRef<FileNameGeneratorDialogComponent>>(MatDialogRef);
    data = inject<FileNameGeneratorDialogData>(MAT_DIALOG_DATA);

    fileNameOutput!: string;
    isSubmitBtnDisabled = false;

    patchFileName(fileName: string) {
        this.fileNameOutput = fileName;
    }

    closeDialog(fileNameOutput?: string) {
        this.dialogRef.close(fileNameOutput);
    }

    isFileNameFormValid(isValid: boolean) {
        this.isSubmitBtnDisabled = !isValid;
    }
}
